// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__I3bEt","dot":"style_dot__Y_Qgi","label":"style_label__2m4KD"};